import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroBell } from '@ng-icons/heroicons/outline';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { toSignal } from '@angular/core/rxjs-interop';
import { startWith, Subject, switchMap } from 'rxjs';
import { BadgeDirective } from '@app/shared/badge/badge.directive';
import { NotificationCardComponent } from '@app/shared/notification-center/notification-card/notification-card.component';
import { NotificationApi } from '@app/core/services/api/notification.api';

@Component({
  selector: 'if-notification-center',
  imports: [NgIcon, CdkOverlayOrigin, CdkConnectedOverlay, BadgeDirective, NotificationCardComponent],
  templateUrl: './notification-center.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideIcons({ heroBell })],
})
export class NotificationCenterComponent {
  protected isOpen = false;
  protected reload$ = new Subject<void>();

  protected readonly notificationApi = inject(NotificationApi);
  protected readonly notifications = toSignal(
    this.reload$.pipe(
      startWith(undefined),
      switchMap(() => this.notificationApi.fetchAll()),
    ),
    { initialValue: [] },
  );

  protected onDelete() {
    this.reload$.next();
  }
}
